export const CONFIGURATION_LOAD = 'CONFIGURATION_LOAD';
export const CONFIGURATION_LOADED = 'CONFIGURATION_LOADED';



// WEBPACK FOOTER //
// ./src/store/modules/conf/types.js